module.exports = __webpack_public_path__ + "img/mlogo.42a0f401.svg";